import { JitsiMeeting } from '@jitsi/react-sdk';
import React, { useRef, useState, useEffect } from 'react';
import { Video, Mic, Camera, MonitorSmartphone, Calendar, FileText, Users, Settings, Clock, Tv, PhoneOff, X } from 'lucide-react';
import './App.css';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../../service/caller';
import ipu from './image/ipu.png';
import pa from './image/pa.png';
import './tele.css';
import Docteur from '../../new/docteur';
import { Modal, Button } from 'react-bootstrap';


const DoctorMeeting = () => {
  const apiRef = useRef();
  const [roomName, setRoomName] = useState(null);
  const [meetingStarted, setMeetingStarted] = useState(false);
  const [joined, setJoined] = useState(false);
  const [showMedicalForm, setShowMedicalForm] = useState(false);
  const [meetingLink, setMeetingLink] = useState('');
  const sidebarRef = useRef(null);
  const [elapsedTime, setElapsedTime] = useState(0); // Temps écoulé en secondes

  const [UserData, setUserData] = useState([]);

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');

        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  const toggleMedicalForm = () => {
    setShowMedicalForm(!showMedicalForm);
  };

  const generateRoomName = () => `DoctorMeeting-${Date.now()}`;

  const startMeeting = () => {
    const newRoomName = generateRoomName();
    setRoomName(newRoomName);
    setMeetingStarted(true);
  };

  const handleApiReady = (apiObj) => {
    apiRef.current = apiObj;
  };

  return (
    <div style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>
      <div className='d-flex justify-content-between'>
        <h1>Consultation en ligne</h1>
        <button
          className={`menu-item ${showMedicalForm ? 'active' : ''}`}
          onClick={toggleMedicalForm}
        >
          <FileText />
        </button>
      </div>

      {!meetingStarted ? (
        <>

          <div className="app-container">
            <ToastContainer /> {/* Conteneur pour afficher les toasts */}
            <div className="main-section">
              <div className="content-wrapper">
                <div className="conference-container">
                  <div className="appointment-header">
                    <div className="appointment-info">
                      <h2>Appointment with</h2>
                      <span className="doctor-name">Markiz Oceane Malwine</span>
                      <span className="timer">00h : 00mn : 00s</span>
                    </div>
                  </div>

                  <div className="video-grid">
                    <div className="video-item">
                      <img src={ipu} alt="Doctor" className="video-frame" />
                      <div className="participant-tag">You </div>
                    </div>
                    <div className="video-item">
                      <img src={pa} alt="Patient" className="video-frame" />
                      <div className="participant-tag">Patient</div>
                    </div>
                  </div>

                  <button
                    onClick={startMeeting}
                    style={{
                      padding: '10px 20px',
                      fontSize: '16px',
                      background: '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }}
                  >
                    Lancer une réunion
                  </button>
                  
                </div>
                {/* Sidebar avec bouton de fermeture */}
                
              </div>
              {/* <button className="ai-assistant">
          <div className="ai-icon">AI</div>
        </button> */}
            </div>
          </div>
        </>
      ) : (
        <div>
          <p>
            📢 Partagez ce lien avec vos patients :
            <strong> {`https://meet.jit.si/${roomName}`} </strong>
          </p>

          <JitsiMeeting
            roomName={roomName}
            onApiReady={handleApiReady}
            getIFrameRef={(iframeRef) => {
              iframeRef.style.height = '600px';
              iframeRef.style.width = '100%';
            }}
          />
          <div
                  ref={sidebarRef}
                  className={`medical-form-sidebar ${showMedicalForm ? 'show' : ''}`}
                >
                  <div className="medical-form-content">
                    {/* <div className="sidebar-header">

                      <button className="close-sidebar" onClick={toggleMedicalForm}>
                        <FileText />
                      </button>
                    </div> */}
                    <Docteur />
                  </div>
                </div>
        </div>
      )}
    </div>
  );
};

export default DoctorMeeting;
